import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { getContent } from '../content';

import './index.scss';
import Graph from './components/Graph';

interface Props {
  tabIndex: number;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('main-page-results-tabs-content');

const Content: React.FC<Enhanced> = ({ t, tabIndex }) => {
  const tabContent = getContent(t)[tabIndex];

  const textWidth = {
    width: tabContent.textWidth,
  };

  return (
    <div className={b({ type: tabContent.modificator })}>
      <div className={b('column')}>
        <div style={textWidth} className={b('text')}>
          {tabContent.text.map((item, index) => (
            <p key={index} className={b('text-item')}>
              {item}
            </p>
          ))}
        </div>
        <div className={b('caption')}>{tabContent.caption}</div>
      </div>
      <Graph tabIndex={tabIndex} />
    </div>
  );
};

export default translate(Content);
